<!--suppress XmlDuplicatedId -->
<script>
    import {deleteBlogById, saveBlogToFirestore, updateBlogById} from "../../config/database-repo";
    import Button from "../../components/ui/Button.svelte";
    import TextInput from "../../components/ui/TextInput.svelte";
    import Form from "../../components/ui/Form.svelte";
    import {blogs} from "../blog/blog-store";
    import AlertMessage from "../../components/ui/AlertMessage.svelte";
    import Modal from "../../components/ui/Modal.svelte";

    let title;
    let inputList = []
    let message;
    let formValid = false;
    let confirmModalOpen = false;
    let selected;

    $: {
        inputList.filter(input => input.type !== 'pic').forEach(input => {
            formValid = !(!input.value || input.value.length < 2 || !title || title.length < 2);
        })
    }

    function onTitleChange({target: {value}}) {
        title = value;
    }

    const onFormSubmit = async () => {
        const content = inputList.map(input => ({
            order: inputList.indexOf(input) + 1,
            value: input.type === 'text' ? input.value : input.value[0],
            type: input.type,
            ...(input.desc && {desc: input.desc})
        }));
        console.log(content);
        const newBlog = {title, content, date: new Date()}
        message = await saveBlogToFirestore(newBlog);
        clear();
    };

    const updateBlog = async () => {
        const {id, ...updatedBlog} = selected;
        message = await updateBlogById(id, updatedBlog);
    }

    const deleteBlog = async () => {
        message = await deleteBlogById(selected);
        $blogs = $blogs.filter(blog => blog.id !== selected.id);
        confirmModalOpen = false;
        selected = null;
    }

    const clearLast = () => {
        const lastItemName = inputList[inputList.length -1].name;
        inputList = inputList.filter(input => input.name !== lastItemName);
    };

    function clear() {
        title = '';
        inputList = [];
    }

    const addInput = type => {
        const input = {
            name: 'input '.concat(inputList.length.toString(), '- ', type),
            value: '',
            type: type
        }
        if (type === 'pic') {
            input.desc = '';
        }
        inputList = [...inputList, input];
    };

    function toggleModal() {
        confirmModalOpen = !confirmModalOpen;
    }
</script>

<!--------------------------------------------------------------------------------------------------------------------->
<AlertMessage {message} />
{#if selected}
    <Form name="Update {selected.title}" on:submit={updateBlog}>
        {#each selected.content.filter(p => p.type === 'text') as paragraph (paragraph.order)}
            <div class="form-control">
                <label for={paragraph.order}>{paragraph.order}</label>
                <textarea id={paragraph.order} bind:value={paragraph.value}></textarea>
            </div>
        {/each}

        <svelte:fragment slot="btns-left">
            <Button clazz="add" on:click={() => {selected = null}}>close</Button>
            <Button clazz="delete" on:click={toggleModal}>delete</Button>
        </svelte:fragment>
    </Form>
{:else}
    <Form name="New Blog" disabled={!formValid} on:submit={onFormSubmit} on:clear={clearLast}>
        <TextInput label="title" value={title} on:input={onTitleChange}/>

        {#each inputList as input}
            <div class="form-control">
                <label for={input.name}>{input.name}</label>
                {#if input.type === 'text'}
                    <textarea id={input.name} bind:value={input.value}></textarea>
                {:else}
                    <div>
                        <input class="fileInput" type="file" id={input.name} bind:files={input.value}>
                        {#if input.value}
                            <img src={URL.createObjectURL(input.value[0])} alt="kok">
                        {/if}
                        <TextInput value={input.desc} on:input={({target: {value}}) => {input.desc = value}} />
                    </div>
                {/if}
            </div>
        {/each}

        <svelte:fragment slot="btns-left">
            <Button on:click={() => {addInput('text')}} clazz="add">add text</Button>
            <Button on:click={() => {addInput('pic')}} clazz="add">add pic</Button>
        </svelte:fragment>
    </Form>
{/if}

<section class="blogs">
    {#each $blogs as blog}
        <div class="blog" on:click={() => {selected = blog}} class:active-blog={blog.title === selected?.title}>
            <h4>{blog.title}</h4>
            <time>{blog.date.toDate().toLocaleDateString("sk-SK")}</time>
            <p>{blog.content[0].value.substring(0, 130).concat('...')}</p>
        </div>
    {/each}
</section>

{#if confirmModalOpen}
    <Modal on:close={toggleModal}>
        <Form name="Confirm Delete of: {selected?.title}">
            <svelte:fragment slot="btns">
                <Button clazz="add" on:click={toggleModal}>close</Button>
                <Button clazz="delete" on:click={deleteBlog}>delete</Button>
            </svelte:fragment>
        </Form>
    </Modal>
{/if}
<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .blogs {
        display: flex;
        flex-flow: column nowrap;
    }
    .blog {
        margin-bottom: 1.5rem;
        padding: 1rem;
        border-radius: 6px;
        background-color: var(--light-grey);
    }
    .active-blog {
        border: 2px solid var(--black-color);
        box-shadow: 1px 1px 6px 6px var(--mid-grey);
    }
    /* ----  */

    .form-control {
        padding-bottom: .8rem;
        position: relative;
        min-height: 70px;
    }

    .form-control > label {
        font-weight: bold;
        padding: 3px;
    }

    .form-control > input, textarea {
        display: block;
        width: 100%;
        border-radius: 6px;
        padding: 2px 3px;
        font-size: 1rem;
    }

    img {
        display: inline;
        width: 100px;
        height: 67px;
        position: absolute;
        left: 300px;
        top: 0;
    }

    textarea {
        resize: none;
        height: 5rem;
        font-family: "Source Sans Pro","Proxima Nova","Helvetica Neue",Verdana,Arial,sans-serif;
    }
</style>
